import React from "react";
import Highlights from "./Highlights";
import ModuloProductoEtapa from "./ModuloProductoEtapa";
// import CarouselAliados from "./CarouselAliados";
import Footer from "./Footer";
import { Link } from "react-router-dom";
// import {
//   BrowserRouter as Router,
//   HashRouter,
//   Switch,
//   Route,
//   Link,
// } from "react-router-dom";
import i18n from "../i18n/index.js";
import "../scss/Aliados.scss";

function Basf() {
  return (
    <>
      <section className="aliado-Fedea">
        <div className="space"></div>
        <div className="Hero">
          <img
            className="banner-hero"
            src="/assets/hero-summit.png"
            alt="hero"
          />
          <div className="info-banner">
            <div className="sectionclass">
              <p>Partners</p>
            </div>
            <div className="nombre-aliado">
              <img
                src="/assets/logo-summit.svg"
                alt="logo"
                className="logo-aliado"
              />
              <Highlights
                classNameH="interna"
                firstLineH={i18n.t(
                  "partners.summit.sectionOne.titleFirstLineHighlight"
                )}
                firstLine={i18n.t("partners.summit.sectionOne.titleFirstLine")}
                secondLineH={i18n.t(
                  "partners.summit.sectionOne.titleSecondLineHighlight"
                )}
                secondLine={i18n.t(
                  "partners.summit.sectionOne.titleSecondLine"
                )}
              />
            </div>
          </div>
        </div>
        <div className="descripccion py-5 mt-5 mt-md-0">
          <img
            src="/assets/deco-gold.svg"
            alt="deco"
            className="deco-descrips"
          />
          <div className="w-90">
            <div className="container">
              <div className="col-12 px-3 pl-md-0 d-flex align-items-center">
                <p className="title-presentacion mb-3 mb-md-0">
                  {i18n.t("partners.summit.sectionTwo.title01")}
                  <br />
                  {i18n.t("partners.summit.sectionTwo.title02")}
                </p>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <p className="text-aliado">
                    {i18n.t("partners.summit.sectionTwo.desc01")}
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="text-aliado">
                    {i18n.t("partners.summit.sectionTwo.desc02")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="servicios py-5">
          <div className="blue-servicio"></div>
          <div className="little-gold"></div>
          <div className="big-gold"></div>
          <div className="grey-servicios"></div>
          <img src="/assets/gold-wave.svg" alt="deco" className="wave-03" />
          <div className="container">
            <div className="grey-servicio"></div>
            <h3>{i18n.t("partners.summit.sectionThree.title")}</h3>
            <div className="row py-3 mx-3 mx-md-0">
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t(
                    "partners.summit.sectionThree.box01.title"
                  )}
                  imgEtapa="../assets/planta00.jpg"
                  claseImgEtapa12=" "
                  imgparter01="/assets/summit-01.png"
                  href01="https://www.summitagro.com.ar/producto.php?id=18"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t(
                    "partners.summit.sectionThree.box02.title"
                  )}
                  imgEtapa="../assets/planta0.jpg"
                  claseImgEtapa12=" "
                  imgparter01="/assets/summit-02.png"
                  href01="https://www.summitagro.com.ar/producto.php?id=20"
                  imgpartner="summit-metolacloros"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa="V1 - Vn"
                  imgEtapa="../assets/planta4.jpg"
                  claseImgEtapa12=" "
                  imgparter01="/assets/summit-03.png"
                  href01="https://www.summitagro.com.ar/producto.php?id=24"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa="R1 - R6"
                  imgEtapa="../assets/planta6.jpg"
                  claseImgEtapa12=" "
                  imgparter01="/assets/summit-04.png"
                  href01="https://www.summitagro.com.ar/producto.php?id=44"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="Beneficios py-5 d-md-flex">
          <img
            src="/assets/gold-beneficios.svg"
            alt="deco"
            className="gold-beneficios"
          />
          <div className="container">
            <h4 className="mb-4">
              {i18n.t("partners.summit.sectionSix.title")}
            </h4>
            <div className="row">
              <div className="col-md-4">
                <a
                  href="http://wa.me/5493512059489"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="cuadro-container">
                    <div className="d-flex flex-column">
                      <img src="/assets/whatsapp.png" alt="multiplica" />
                      <p>{i18n.t("partners.summit.sectionSix.box01")}</p>
                      <p className="dest">+54 9 3512 05-9489</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="cta-aliados py-5">
          <div className="container">
            <div className="col-12">
              <div href="#" className="interesado-aliados">
                <Link to="/contacto">
                  <div className="row justify-content-center align-items-center">
                    <p>{i18n.t("partners.cta")}</p>
                    <img
                      src="/assets/arrow-next.svg"
                      alt="arrow"
                      className="arrow-cta"
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Basf;
